import React, { useContext, useState } from 'react';
import { useSelector } from 'react-redux';

const BoardContext = React.createContext();

export const useBoardContext = () => useContext(BoardContext);

export const BoardProvider = ({ children }) => {

    const [selectedHardware, setSelectedHardware] = useState([]);

    const boardList = useSelector(state => state.hardware.boardList.payload);

    const handleBulkSelect = (checked) => {
        if (checked) {
            const allSelect = boardList.map((item) => { return item.hardware_uuid });
            setSelectedHardware(allSelect);
        }
        else setSelectedHardware([]);
    }

    const value = {
        selectedHardware, setSelectedHardware,
        boardList, handleBulkSelect
    };

    return (
        <BoardContext.Provider value={value}>
            {children}
        </BoardContext.Provider>
    )

}
